import { CONNECTION_CATEGORY_FILE, CONNECTION_CATEGORY_DATABASE } from './connectionCategories';
import { RESOURCE_TYPE_SINK } from './resourceTypes';

export default {
  [RESOURCE_TYPE_SINK]: {
    [CONNECTION_CATEGORY_DATABASE]: ['Record Attribute Name', 'Database Column Name'],
    [CONNECTION_CATEGORY_FILE]: ['Record Attribute Name', 'File Column Name'],
    default: ['Record Attribute Name', 'Column Name'],
  },
  default: ['Nexset Attribute Name', 'Database Column Name'],
};
